import {CreationInfoType} from "../types/creation-info.type";

export interface PlayerBasicInfoDto {
  tenantId: number;
  id: number;
  firstName: string;
  lastName: string;
  school: string;
  number?: number;
  position?: PlayerPosition;
  height?: number;
  class?: PlayerClass
}

export interface PlayerStatsDto {
  sideout: SideoutStatsDto
  firstBallSideout: FirstBallSideoutStatsDto
  serving: ServingStatsDto;
}

export interface SideoutStatsDto {
  opportunities: number;
  pointsWon: number;
  kills: number;
  errors: number;
  aced: number;
  percentage: number;
  transitionWinPercentage: number;
}

export interface FirstBallSideoutStatsDto {
  opportunities: number;
  kills: number;
  errors: number;
  percentage: number;
  efficiencyPercentage: number;
}

export interface ServingStatsDto {
  opportunities: number;
  pointsWon: number;
  aces: number;
  opponentOutOfSystemPasses: number;
  errors: number;
  acePercentage: number;
  knockoutPercentage: number;
  efficiencyPercentage: number;
  transitionWinPercentage: number;
}

export type PlayerPosition = 'Blocker' | 'Defender' | 'Hybrid';
export const PlayerPosition = {
  Blocker: 'Blocker' as PlayerPosition,
  Defender: 'Defender' as PlayerPosition,
  Hybrid: 'Hybrid' as PlayerPosition,
}
export type PlayerClass = 'Freshman' | 'Sophomore' | 'Junior' | 'Senior' | 'Graduate' | 'Other';
export const PlayerClass = {
  Freshman: 'Freshman' as PlayerClass,
  Sophomore: 'Sophomore' as PlayerClass,
  Junior: 'Junior' as PlayerClass,
  Senior: 'Senior' as PlayerClass,
  Other: 'Other' as PlayerClass,
}

export type PlayerInfoDto = PlayerBasicInfoDto & PlayerStatsDto & CreationInfoType
export type AddPlayerDto = Omit<PlayerBasicInfoDto, 'id' | 'tenantId'>
export type UpdatePlayerDto = Partial<AddPlayerDto>

export const validateAddPlayerDto = (player: Partial<AddPlayerDto>): string | null => {
  const requiredFields = ['firstName', 'lastName', 'school'];
  const errors: string[] = [];

  for (const field of requiredFields) {
    if (player[field as keyof Partial<AddPlayerDto>] == null) {
      errors.push(`"${field}" is missing or null.`);
    }
  }

  if (errors.length > 0) {
    return `Validation failed: ${errors.join(' ')}`;
  }

  return null;
}
